/** Optional browser APIs: never treat API state as proof of speaker output. */
type AudioSession = EventTarget & { type: string; readonly state?: string };
export function browserAudioSession(): AudioSession | undefined {
  return (navigator as Navigator & { audioSession?: AudioSession }).audioSession;
}
export function configureMusicAudioSession() {
  try { const session = browserAudioSession(); if (session) session.type = 'playback'; } catch { /* Unsupported implementations keep their native policy. */ }
}
export function releaseMusicAudioSession() {
  try { const session = browserAudioSession(); if (session?.type === 'playback') session.type = 'auto'; } catch { /* Optional API. */ }
}
export const MUSIC_MEDIA_ACTIONS: MediaSessionAction[] = ['play', 'pause', 'stop', 'seekto', 'seekbackward', 'seekforward', 'previoustrack', 'nexttrack'];
export function clearMusicMediaSession() {
  if (!('mediaSession' in navigator)) return;
  for (const action of MUSIC_MEDIA_ACTIONS) { try { navigator.mediaSession.setActionHandler(action, null); } catch { /* Unsupported action. */ } }
  navigator.mediaSession.metadata = null;
  navigator.mediaSession.playbackState = 'none';
  try { navigator.mediaSession.setPositionState(); } catch { /* Optional API. */ }
}
export function updateMusicMediaPosition(audio: HTMLAudioElement | null) {
  if (!audio || !('mediaSession' in navigator) || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
  try { navigator.mediaSession.setPositionState({ duration: audio.duration, playbackRate: audio.playbackRate || 1, position: Math.max(0, Math.min(audio.duration, audio.currentTime)) }); } catch { /* Optional API. */ }
}

// Explicit local opt-in only. No network, URLs, titles, account identifiers or
// persistent event export. This bounded snapshot helps a real-device inspector.
export function recordMusicDiagnostic(event: string, audio: HTMLAudioElement | null, context: AudioContext | undefined, volume: number, muted: boolean, intended: boolean) {
  try {
    if (sessionStorage.getItem('untangled:music-diagnostics') !== '1') return;
    const host = window as Window & { __untangledMusicDiagnostics?: object[] };
    const session = browserAudioSession();
    const row = { event, atMs: Math.round(performance.now()), visibility: document.visibilityState, paused: audio?.paused, ended: audio?.ended, position: audio?.currentTime, readyState: audio?.readyState, errorCode: audio?.error?.code ?? null, context: context?.state ?? 'native', gain: muted ? 0 : volume, muted, intended, audioSession: session?.state ?? 'unsupported', audioSessionType: session?.type ?? 'unsupported' };
    host.__untangledMusicDiagnostics = [...(host.__untangledMusicDiagnostics || []).slice(-79), row];
  } catch { /* Private browsing may deny diagnostic opt-in storage. */ }
}
